<template>
  <div>
    <ed-esocial
      :key="$root.$session.versao"
    />
  </div>
</template>

<script>
import EdEsocial from "@/components/esocial/index";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {
    EdEsocial
  },
  mounted() {
  },
  beforeDestroy() {
  },
  provide() {
    return {
    };
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  },
};
</script>
